import { Text } from '@belong/ui';
import { STRINGS } from 'maintenance/strings';

type Props = {
  type: 'recurring' | 'non-recurring';
};

export function EmptyTaskList({ type }: Props) {
  return (
    <div className="flex items-center justify-center rounded border border-dashed border-gray p-lg">
      <Text className="text-dark-gray">
        {type === 'recurring'
          ? STRINGS['no-recurring-services']
          : STRINGS['no-tasks']}
      </Text>
    </div>
  );
}
